function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useState } from 'react';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
const MIN_YEAR = 2021;
const MAX_YEAR = dayjs().year();
const clearRangeFields = {
    year_from: undefined,
    year_to: undefined
};
export default function LineChartFilter({ onChange, enableYearRange = false }) {
    const _useState = useState({
        mode: 'month',
        year: dayjs().year(),
        month: dayjs().month() + 1
    }), _useState2 = _slicedToArray(_useState, 2), period = _useState2[0], setPeriod = _useState2[1];
    const emit = next => {
        setPeriod(next);
        onChange(next);
    };
    const handleOnChange = mode => {
        var _a;
        if (mode === 'year') {
            emit(_objectSpread({
                mode: 'year',
                year: period.year,
                month: undefined
            }, clearRangeFields));
            return;
        }
        if (mode === 'month') {
            emit(_objectSpread({
                mode: 'month',
                year: period.year,
                month: (_a = period.month) !== null && _a !== void 0 ? _a : dayjs().month() + 1
            }, clearRangeFields));
            return;
        }
        if (mode === 'range' && enableYearRange) {
            const yto = Math.min(period.year, MAX_YEAR);
            const yfrom = Math.max(MIN_YEAR, yto - 2);
            emit({
                mode: 'range',
                year: yto,
                year_from: yfrom,
                year_to: yto,
                month: undefined
            });
        }
    };
    const handleYearChange = d => {
        if (!d)
            return;
        emit(_objectSpread({
            mode: 'year',
            year: d.year(),
            month: undefined
        }, clearRangeFields));
    };
    const handleMonthChange = d => {
        if (!d)
            return;
        emit(_objectSpread({
            mode: 'month',
            year: d.year(),
            month: d.month() + 1
        }, clearRangeFields));
    };
    const handleYearRangeChange = dates => {
        if (!(dates === null || dates === void 0 ? void 0 : dates[0]) || !dates[1])
            return;
        const y0 = dates[0].year();
        const y1 = dates[1].year();
        emit({
            mode: 'range',
            year: Math.max(y0, y1),
            year_from: Math.min(y0, y1),
            year_to: Math.max(y0, y1),
            month: undefined
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 w-fit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleOnChange('year'),
        className: period.mode === 'year' ? '!bg-[#f0c52a36]' : ''
    }, "\u5E74"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleOnChange('month'),
        className: period.mode === 'month' ? '!bg-[#f0c52a36]' : ''
    }, "\u6708"), enableYearRange ? /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleOnChange('range'),
        className: period.mode === 'range' ? '!bg-[#f0c52a36]' : ''
    }, "\u671F\u9593") : null), period.mode === 'year' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "year",
        value: dayjs(`${period.year}-01-01`),
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleYearChange
    }), period.mode === 'month' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "month",
        value: dayjs(`${period.year}-${period.month}-01`),
        format: "YYYY-MM",
        allowClear: false,
        disabledDate: c => c && c > dayjs().endOf('month'),
        onChange: handleMonthChange
    }), enableYearRange && period.mode === 'range' && period.year_from != null && period.year_to != null && /*#__PURE__*/ React.createElement(DatePicker.RangePicker, {
        picker: "year",
        value: [dayjs().year(period.year_from), dayjs().year(period.year_to)],
        allowClear: false,
        format: "YYYY",
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleYearRangeChange
    }));
}
